'use client';

import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Text,
} from '@chakra-ui/react';
import { ArrowRightSLineIcon, buttonIconSizeSm } from '@/components/Icons';
import { FC, memo, useEffect } from 'react';
import { IBreadcrumbLink } from '@/components/UI/Page/PageBreadcrumb/types';
import { useRouter } from 'next/navigation';
import colors from '@/constants/theme/colors';
import Link from 'next/link';

interface PageBreadcrumbProps {
  links: IBreadcrumbLink[];
}
const PageBreadcrumb: FC<PageBreadcrumbProps> = memo(({ links = [] }) => {
  const router = useRouter();

  useEffect(() => {
    links.forEach(({ path }) => {
      router.prefetch(path);
    });
  }, [links, router]);

  return (
    <Box w="100%" maxW="100%">
      <Breadcrumb
        separator={<ArrowRightSLineIcon size={buttonIconSizeSm} />}
        fontSize="0.9375rem"
        lineHeight="1.25rem"
        w="100%"
        overflow="hidden"
      >
        {links.map((l) => {
          const { name, path, isCurrentPage } = l;
          return (
            <BreadcrumbItem key={name}>
              <BreadcrumbLink
                fontWeight={isCurrentPage ? '600' : '400'}
                color={
                  isCurrentPage ? colors.primary[300] : colors.primary[100]
                }
                isCurrentPage={isCurrentPage}
                as={Link}
                href={path}
              >
                <Text
                  w="max-content"
                  maxW={{
                    base: '8rem',
                    md: '10rem',
                    xl: '15rem',
                    '2xl': 'none',
                  }}
                  textOverflow="ellipsis"
                  whiteSpace="nowrap"
                  overflow="hidden"
                >
                  {name}
                </Text>
              </BreadcrumbLink>
            </BreadcrumbItem>
          );
        })}
      </Breadcrumb>
    </Box>
  );
});

PageBreadcrumb.displayName = 'PageBreadcrumb';

export default PageBreadcrumb;
